import React, { Component } from 'react'
import { connect } from 'react-redux'

import ContainerCenterHeader from '../ContainerCenterHeader/index'
import VideoWindowList from '../VideoWindowList/index'
import VideoWindowMine from '../VideoWindowMine/index'
import Chatroom from '../Chatroom/index'
import PmWindowsList from '../PmWindowsList/index'

class ContainerCenter extends Component {
    state = { visible: true, touchstart: null };
    timer = null;

    handleWheel = event => {
        if (typeof event.deltaY === 'number') {
            const visible = event.deltaY <= 0;
            if (visible) {
                this.showHeader();
            } else {
                this.hideHeader();
            }
        }
    };

    showHeader = () => {
        const { visible } = this.state;
        if (!visible) {
            clearTimeout(this.timer);
            this.setState({ visible: true },
                () => this.hideByTimeout());
        }
    };

    hideHeader = () => {
        const { visible } = this.state;
        const { leftShown,rightShown } = this.props;
        if (visible && !(leftShown || rightShown)) {
            clearTimeout(this.timer);
            this.setState({ visible: false });
        }
    };

    hideByTimeout = () => {
        clearTimeout(this.timer);
        this.timer = setTimeout(() => {
            this.hideHeader()
        }, 5000);
    };

    handleTouchStart = event => { 
        this.setState({ touchstart: event });
    };

    handleTouchMove = event => {
        const { touchstart } = this.state;
        if (!touchstart) return;
        
        const visible = touchstart.touches[0].clientY < event.touches[0].clientY;
        if (visible) {
            this.showHeader();
        } else {
            this.hideHeader();
        }
    };

    componentWillReceiveProps(nextProps) {
        const { pm } = nextProps;
        const { props } = this;

        let maximizedPm = false;

        Object.keys(pm.conversations).forEach(key => {
            if (pm.conversations[key].view.maximized) {
                maximizedPm = true;
                this.hideByTimeout();
            }
        });

        Object.keys(pm.conversations).forEach(key => {
            if (props.pm.conversations[key]) {
                if (!this.props.pm.conversations[key].unread && pm.conversations[key].unread) {
                    this.showHeader();
                }
            } else {
                this.showHeader();
            }
        });
    }

    componentDidMount() {
        document.addEventListener('wheel', this.handleWheel);
        document.addEventListener('touchstart', this.handleTouchStart);
        document.addEventListener('touchmove', this.handleTouchMove);

        this.hideByTimeout();
    }

    componentWillUnmount() {
        document.removeEventListener('wheel', this.handleWheel);
        document.removeEventListener('touchstart', this.handleTouchStart);
        document.removeEventListener('touchmove', this.handleTouchMove);
    }

    render() {
        const { visible } = this.state;
        const { rooms, video, myVideo, pm, notifications } = this.props;

        let pmShow = false;
        Object.keys(pm.conversations).forEach(key => {
            if (pm.conversations[key].view.maximized) {
                pmShow = true;
            }
        });

        const streamsMargin = visible && (myVideo.shown || Object.keys(video).length > 0);
        const chatLogMargin = visible && !(myVideo.shown || Object.keys(video).length > 0);


        const pmMargin = visible && !(myVideo.shown || Object.keys(video).length > 0) && pmShow;
        const notificationsMargin = visible && !(myVideo.shown || Object.keys(video).length > 0) && notifications;

        return (
            <div className="center-cont">
                <ContainerCenterHeader visible={visible} />
                <div className={`all-streams ${streamsMargin ? 'margin' : ''}`}>
                    <VideoWindowList />
                    <VideoWindowMine />
                </div>
                {Object.values(rooms).map(room => {
                    return (
                        <Chatroom
                            room={room}
                            key={room.roomid}
                            chatLogMargin={chatLogMargin}
                            newMessageBtnHandler={this.hideHeader}
                            visible={room.roomid === this.props.visibleChatrooms.roomid}
                        />
                    )})
                }
                
                <PmWindowsList pmMargin={pmMargin}/>
                <div id="notifications-window" className={`notifications-window ${notificationsMargin ? 'margin' : ''}`}/>
            </div>
        );
    }
}

function mapStateToProps(state, ownProps) {
    return {
        visibleChatrooms: state.visibleChatrooms,
        rooms: state.rooms,
        leftShown:state.sidebars.leftShown,
        rightShown:state.sidebars.rightShown,
        myVideo: state.myVideoWindow,
        pm: state.pm,
        video: state.videoStreams,
        notifications: state.notifications.showNotificationsWindow
    }
}

export default connect(mapStateToProps)(ContainerCenter);



// WEBPACK FOOTER //
// ./src/components/bobtv-neo/ContainerCenter/index.js